export default "__VITE_ASSET__CgfnXorK__"